import monarchEstatesLogo from "@/assets/logos/monarch-estates.webp";
import monarchDesignLogo from "@/assets/logos/monarch-design.webp";
import artForestLogo from "@/assets/logos/art-forest.webp";
import wishingWellLogo from "@/assets/logos/wishing-well.webp";
import wishingWellBanner from "@/assets/images/wishing-well-banner.webp";
import artForestBanner from "@/assets/images/art-forest-banner.webp";

// Central, single source of truth for the four venture portals. Adding a
// future venture only requires appending an entry here + (optionally) a
// logo import -- no page templates need to change.
export const VENTURES = [
  {
    slug: "monarch-estates",
    name: "Monarch Estates",
    category: "01 · Private Real Estate Advisory",
    categoryEyebrow: "01",
    logo: monarchEstatesLogo,
    editorialImage: "https://images.unsplash.com/photo-1757439402268-1da284675170?crop=entropy&cs=srgb&fm=jpg&q=85",
    headline: "Your Kingdom.",
    description:
      "A private real estate advisory built for discerning homebuyers, HNI and UHNI investors, NRI clients and businesses seeking premium residential, commercial and land opportunities.",
    expandedDescription:
      "Monarch Estates is the private real estate advisory and investment-management arm of Gopi Gadhvi Group. It serves discerning homebuyers, HNI and UHNI investors, NRI clients, professionals and businesses seeking premium residential, commercial, land and long-term portfolio opportunities. Its approach places suitability before salesmanship, diligence before urgency and long-term value before short-term persuasion. Monarch Estates is not built to show clients everything available. It is built to help them identify what is appropriate.",
    status: "Coming Soon",
    link: null,
    instagram: "https://www.instagram.com/monarchestateofficial/",
    facebook: "https://www.facebook.com/share/1DFr27CADs/?mibextid=wwXIfr",
    youtube: null,
    linkedin: null,
    enquiryType: "Monarch Estates Enquiry",
    brandVars: {
      "--brand-a": "#2A0F16",
      "--brand-b": "rgba(185,167,123,0.20)",
      "--brand-glow": "rgba(185,167,123,0.10)",
      "--brand-shadow": "rgba(185,167,123,0.24)",
    },
  },
  {
    slug: "monarch-design-studio",
    name: "Monarch Design Studio",
    category: "02 · Premium Interior Design",
    categoryEyebrow: "02",
    logo: monarchDesignLogo,
    editorialImage: "https://images.unsplash.com/photo-1643376452350-97eadd2c417f?crop=entropy&cs=srgb&fm=jpg&q=85",
    headline: "Spaces That Transform How You Live",
    description:
      "Conscious luxury interiors shaped through architecture, emotion and psychological intentionality. Beautiful spaces designed not merely to impress, but to change how they are experienced.",
    expandedDescription:
      "Monarch Design Studio creates premium interiors grounded in aesthetics, architecture, emotion and psychological intentionality. Its philosophy begins with the understanding that a space influences far more than appearance. It shapes behaviour, mood, energy, comfort and the way people experience daily life. The studio seeks to create interiors that are elegant without being impersonal, luxurious without becoming excessive and emotionally powerful without sacrificing function. Every environment is approached as a lived experience rather than a decorative composition.",
    status: "Coming Soon",
    link: null,
    instagram: null,
    facebook: null,
    youtube: null,
    linkedin: null,
    enquiryType: "Monarch Design Studio Enquiry",
    brandVars: {
      "--brand-a": "#3D1522",
      "--brand-b": "rgba(201,147,131,0.18)",
      "--brand-glow": "rgba(201,147,131,0.09)",
      "--brand-shadow": "rgba(201,147,131,0.22)",
    },
  },
  {
    slug: "the-art-forest",
    name: "The Art Forest",
    category: "03 · Art, Music, Books & Digital Creations",
    categoryEyebrow: "03",
    logo: artForestLogo,
    editorialImage: artForestBanner,
    headline: "Create. Inspire. Transform.",
    description:
      "An enchanted creative world of digital art, healing music, meaningful books, imaginative products and tools designed to awaken emotion, beauty and possibility.",
    expandedDescription:
      "The Art Forest is the creative and digital-products world of Gopi Gadhvi Group. It brings together digital art, healing music, meaningful books, imaginative resources, creative tools and future digital experiences. The brand is designed as an enchanted but intelligent creative universe where beauty, emotion and usefulness grow together. Its purpose is not simply to produce more content. It is to create work that inspires, comforts, awakens imagination and opens new possibilities.",
    status: "live",
    link: "https://www.theartforest.com",
    linkLabel: "Enter The Art Forest",
    instagram: null,
    facebook: null,
    youtube: null,
    linkedin: null,
    enquiryType: "The Art Forest Enquiry",
    brandVars: {
      "--brand-a": "#241012",
      "--brand-b": "rgba(194,168,104,0.20)",
      "--brand-glow": "rgba(194,168,104,0.10)",
      "--brand-shadow": "rgba(194,168,104,0.24)",
    },
  },
  {
    slug: "the-wishing-well",
    name: "The Wishing Well",
    category: "04 · Life Alchemy & Personal Transformation",
    categoryEyebrow: "04",
    logo: wishingWellLogo,
    editorialImage: wishingWellBanner,
    headline: "The Journey Inward Changes Everything",
    description:
      "A sanctuary for reflection, personal transformation and inner alchemy, created to help people move beyond fear, reconnect with themselves and consciously shape their lives.",
    expandedDescription:
      "The Wishing Well is the personal-transformation and Life Alchemy world of Gopi Gadhvi Group. It is a sanctuary for reflection, self-understanding and the conscious transformation of one's inner and outer life. Through thoughtful content, writing, frameworks and future experiences, The Wishing Well explores what becomes possible when people move beyond fear, reconnect with themselves and begin living deliberately. It should feel like a wise, quiet space where depth is welcomed and transformation is treated with tenderness, courage and honesty.",
    status: "live",
    link: "https://www.thewishingwell.love",
    linkLabel: "Enter The Wishing Well",
    instagram: "https://www.instagram.com/thewishingwell.love.original/",
    facebook: "https://www.facebook.com/share/1EVRmADKVo/?mibextid=wwXIfr",
    youtube: null,
    linkedin: null,
    enquiryType: "The Wishing Well Enquiry",
    brandVars: {
      "--brand-a": "#1E1018",
      "--brand-b": "rgba(107,32,53,0.22)",
      "--brand-glow": "rgba(184,176,160,0.10)",
      "--brand-shadow": "rgba(184,176,160,0.20)",
    },
  },
];

export const getVentureBySlug = (slug) => VENTURES.find((v) => v.slug === slug);
